export const APP_LINKS = {
  // App Store link (update when app is published)
  IOS_APP_STORE: 'https://apps.apple.com/app/idXXXXXXXXX',

  // TestFlight beta link (update when beta starts)
  IOS_TESTFLIGHT: 'https://testflight.apple.com/join/XXXXXXXX',

  // Waitlist page (current fallback)
  BETA_WAITLIST: '/waitlist',

  // Deep link for installed app
  DEEP_LINK: 'intellitrain://',
};

export const getIOSLink = (isBetaLive = false, isAppLive = false) => {
  if (isAppLive) return APP_LINKS.IOS_APP_STORE;
  if (isBetaLive) return APP_LINKS.IOS_TESTFLIGHT;
  return APP_LINKS.BETA_WAITLIST; // Default to waitlist
};
